module.exports = __webpack_public_path__ + "img/personalAccount.50e529cd.svg";